import { z } from 'zod'

export const TransactionStatusSchema = z.number().transform((value) => {
  switch (value) {
    case 1:
      return 'Completed'
    case 2:
      return 'Declined'
    case 3:
      return 'In review'
    case 4:
      return 'Refunded by Provider'
    case 5:
      return 'Partially Refunded by Provider'
    case 6:
      return 'Partial Refund in Progress'
    default:
      return 'Unknown'
  }
})

export type TransactionStatus = z.infer<typeof TransactionStatusSchema>
